import type { SectionDef } from "../inspector/schema";
import { KhrVariants } from "./custom/KhrVariants";
import { MaterialConfiguratorControl } from "./custom/MaterialConfiguratorControl";
import { SwitchNodeControl } from "./custom/SwitchNodeControl";
import { VariationConfiguratorControl } from "./custom/VariationConfiguratorControl";

/**
 * Configurators tab: Variation Configurator (v32 — the product-level
 * material/object variation sets shoppers switch between, mirrored in the
 * customer-facing grid panel), Material Configurator (v22, switchable material
 * variations per part), Switch Node (switchable geometry), and KHR material
 * variants authored into the GLB.
 */
export const configuratorsSections: SectionDef[] = [
  {
    id: "variationConfigurator",
    title: "Variation Configurator",
    rows: [{ id: "varcfg", kind: "custom", label: "", component: VariationConfiguratorControl }],
  },
  {
    id: "materialConfigurator",
    title: "Material Configurator",
    rows: [{ id: "matcfg", kind: "custom", label: "", domains: ["selection"], component: MaterialConfiguratorControl }],
  },
  {
    id: "switchNode",
    title: "Switch Node",
    defaultCollapsed: true,
    rows: [{ id: "switch", kind: "custom", label: "", component: SwitchNodeControl }],
  },
  {
    id: "khr",
    title: "KHR Material Variants",
    defaultCollapsed: true,
    rows: [{ id: "khr", kind: "custom", label: "", component: KhrVariants }],
  },
];
